module.exports = __webpack_public_path__ + "static/media/natalie-portman-icon.b8de766e.jpg";